module.exports = {"menu":{"site":"Site","userGroup":"User Group","user":"User"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/menu.json
// module id = 111
// module chunks = 35